<template>
  <div>

    <vx-card card-border class="mb-4" title="Datos del cliente" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">DNI/CIF *</span>
          </div>
          <div>
            <vx-input-group>
              <vs-input class="w-full" data-vv-as="DNICliente" v-validate="'required|alpha_num|checkDNI'" name="dniCliente" v-model="cliente.persona.dni" 
                v-on:keyup="borrarCamposCliente" @input="v => { cliente.persona.dni = v.toUpperCase()}"/>
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary"  icon-pack="feather" icon="icon-search" @click="abrirPopupBuscarPersona('CLIENTE')" />
                </div>
              </template>
            </vx-input-group>
            <span class="text-danger text-sm"  v-show="errors.has('dniCliente')">{{ errors.first('dniCliente') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.tipoCliente !== 'EMPRESA'">
          <div>
            <span class="campoObligatorio">Fecha nacimiento *</span>
          </div>
          <div>
            <flat-pickr name="fechaNacimiento" data-vv-as="FECHA NACIMIENTO" v-validate="'required'" :config="configdateTimePicker" 
              v-model="cliente.persona.fechaNacimiento" :disabled="fechaNacimientoClienteDisabled" />
            <span class="text-danger text-sm"  v-show="errors.has('fechaNacimiento')">{{ errors.first('fechaNacimiento') }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Nombre o razón social *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="NOMBRE" v-validate="'required'" name="nombreCliente" v-model="cliente.persona.nombre" 
              :disabled="clienteDisabled" @input="v => { cliente.persona.nombre = v.toUpperCase()}" />
            <span class="text-danger text-sm"  v-show="errors.has('nombreCliente')">{{ errors.first('nombreCliente') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full" v-if="operacion.tipoCliente !== 'EMPRESA'">
          <div>
            <span>Apellidos</span>
          </div>
          <div>
            <vs-input class="w-full" name="apellidos" v-model="cliente.persona.apellidos" :disabled="clienteDisabled" @input="v => { cliente.persona.apellidos = v.toUpperCase()}" />
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Móvil de contacto *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="TELÉFONO DE CONTACTO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 9 }" 
              name="telefonoCliente" v-model="cliente.telefono" />
            <span class="text-danger text-sm"  v-show="errors.has('telefonoCliente')">{{ errors.first('telefonoCliente') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">E-mail *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="E-MAIL" v-validate="'email'" name="emailCliente" v-model="cliente.email" />
            <span class="text-danger text-sm"  v-show="errors.has('emailCliente')">{{ errors.first('emailCliente') }}</span>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-4" title="Dirección del cliente (dirección de facturación)" title-color="dark" collapseAction>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Dirección *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="DIRECCIÓN" v-validate="'required'" name="direccionCliente" v-model="direccionCliente.direccion"
              @input="v => { direccionCliente.direccion = v.toUpperCase()}" />
            <span class="text-danger text-sm"  v-show="errors.has('direccionCliente')">{{ errors.first('direccionCliente') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
            <div>
              <span class="campoObligatorio">Núm. *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="NÚMERO" v-validate="{ required: true, regex: /^\+?([0-9]+)$/ }" name="numeroCliente" 
                v-model="direccionCliente.numero" @input="v => { direccionCliente.numero = v.toUpperCase()}"/>
              <span class="text-danger text-sm"  v-show="errors.has('numeroCliente')">{{ errors.first('numeroCliente') }}</span>
            </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Portal</span>
          </div>
          <div>
            <vs-input class="w-full" name="portal" v-model="direccionCliente.portal" @input="v => { direccionCliente.portal = v.toUpperCase()}"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Escalera</span>
          </div>
          <div>
            <vs-input class="w-full" name="escalera" v-model="direccionCliente.escalera" @input="v => { direccionCliente.escalera = v.toUpperCase()}"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
            <div>
              <span class="campoObligatorio">Planta *</span>
            </div>
            <div>
              <vs-input class="w-full" data-vv-as="PLANTA" v-validate="'required'" name="plantaCliente" v-model="direccionCliente.planta" 
                @input="v => { direccionCliente.planta = v.toUpperCase()}"/>
              <span class="text-danger text-sm"  v-show="errors.has('plantaCliente')">{{ errors.first('plantaCliente') }}</span>
            </div>
        </div>
        <div class="vx-col sm:w-1/12 w-full">
          <div>
            <span>Puerta</span>
          </div>
          <div>
            <vs-input class="w-full" name="puerta" v-model="direccionCliente.puerta" @input="v => { direccionCliente.puerta = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span>Localidad</span>
          </div>
          <div>
            <vs-input class="w-full" name="localidad" v-model="direccionCliente.localidad" @input="v => { direccionCliente.localidad = v.toUpperCase()}"/>
          </div>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div>
            <span class="campoObligatorio">Municipio *</span>
          </div>
          <div>
            <select-val-municipio class="w-full" name="municipio" v-model="direccionCliente.municipio" :municipioSelected="direccionCliente.municipio"
              ref="cambiarEstado"/>
          </div>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col sm:w-2/12 w-full">
          <div>
            <span class="campoObligatorio">Cód. Postal *</span>
          </div>
          <div>
            <vs-input class="w-full" data-vv-as="CÓD. POSTAL" v-validate="{ required: true, regex: /^\+?([0-9]+)$/, min: 5, max: 5 }" 
                name="cpCliente" v-model="direccionCliente.cp" />
              <span class="text-danger text-sm"  v-show="errors.has('cpCliente')">{{ errors.first('cpCliente') }}</span>
          </div>
        </div>
        <div class="vx-col sm:w-4/12 w-full">
          <div>
            <span class="campoObligatorio">Provincia *</span>
          </div>
          <div>
            <select-val-provincia class="w-full" name="provincia" v-model="direccionCliente.provincia" :provinciaSelected="direccionCliente.provincia" />
          </div>
        </div>
        <div class="vx-col sm:w-6/12 w-full">
          <div>
            <span>Pais</span>
          </div>
          <div>
            <vs-input class="w-full" name="pais" v-model="direccionCliente.pais" @input="v => { direccionCliente.pais = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
    </vx-card>
    
    <popup-buscar-persona :popupProps="popupProps" @aceptar="popupBuscarPersonaAction" ref="consultarDni" />

    <vs-popup title="¿Actualizar dirección de instalación?" :active.sync="popupActualizarDireccionInstalacionActivo" button-close-hidden >
      <p>
        En la operación está indicado que la dirección de instalación es la misma que la del cliente. <br>
        ¿Desea actualizar también la dirección de instalación?
      </p>
      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" @click="actualizarDireccionInstalacion">Actualizar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="noActualizarDireccionInstalacion">No actualizar</vs-button>
      </div>
    </vs-popup>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'
import personasStore from '@/store/gestion/personas/index.js'

import selectValMunicipio from '@/views/common-components/selectValMunicipio'
import selectValProvincia from '@/views/common-components/selectValProvincia'
import popupBuscarPersona from '@/views/common-components/popupBuscarPersona'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

export default {
  name: 'OperacionesEditCliente',
  components: {
    selectValMunicipio,
    selectValProvincia,
    popupBuscarPersona,
    flatPickr,
    SpanishLocale
  },
  data () {
    return {
      operacion: {},
      cliente: {},
      direccionCliente: {},
      clienteId: null,
      clienteTelefono: null,
      clienteEmail: null,
      clienteDireccionId: null,

      // Propiedades para deshabilitar campos que se poden obter si a persoa xa existe na BD
      clienteDisabled: true,
      fechaNacimientoClienteDisabled: true,

      popupActualizarDireccionInstalacionActivo: false,

      //Flat Date Picker
      configdateTimePicker: {
        locale: SpanishLocale,
        altInput: true,  // para que mostre ao usuario a data nun formato e devolva ao servidor un formato distinto (altFormat)
        altFormat: 'd/m/Y',
        dateFormat: 'Y-m-d',
        mode: 'single',
        defaultDate: null,
        wrap: true
      },
      // popupBuscarPersona
      popupProps: {
        activo: false,
        dni: null,
        relacion: null,  // Relación da persoa coa operación: CLIENTE, DECISOR ou TITULAR
        origenLlamadaPopUp: 'MODIFICAR'  // O Popup ábrese desde a pantalla de modificación da operación
      }
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any() || this.cliente.persona.dni === null || this.cliente.persona.dni === undefined 
        || (this.operacion.tipoCliente !== 'EMPRESA' 
          && (this.cliente.persona.fechaNacimiento === null || this.cliente.persona.fechaNacimiento === undefined))
        || this.cliente.persona.nombre === null || this.cliente.persona.nombre === undefined 
        || this.cliente.telefono === null || this.cliente.telefono === undefined 
        || this.cliente.email === null || this.cliente.email === undefined 
        || this.direccionCliente.direccion === null || this.direccionCliente.direccion === undefined
        || this.direccionCliente.municipio === null || this.direccionCliente.municipio === undefined 
        || this.direccionCliente.cp === null || this.direccionCliente.cp === undefined
        || this.direccionCliente.provincia === null || this.direccionCliente.provincia === undefined) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    async guardar () {
      if (!this.validateForm) return

      let cambios = false  // Para saber si se cambiou algún dato e hai que recargar a operación no State
      let errorAlGuardar = false  // Para saber si se produce algún erro gardando o formulario

      if (this.clienteId !== this.cliente.persona.id) {  // No caso de cambiarse a persoa que figura como cliente...
        this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
        cambios = true

        if (this.clienteId === null) {  // A persoa non se atopou na BD polo que hai que dala de alta
          // Construimos un novo obxecto Persona e Direccion e gardámola
          const p = { direcciones: [] }
          const d = {}
          p.dni = this.cliente.persona.dni
          p.nombre = this.cliente.persona.nombre
          p.apellidos = this.cliente.persona.apellidos
          p.fechaNacimiento = this.cliente.persona.fechaNacimiento === undefined || this.cliente.persona.fechaNacimiento === null ? null : this.cliente.persona.fechaNacimiento

          d.direccion = this.direccionCliente.direccion
          d.numero = this.direccionCliente.numero
          d.portal = this.direccionCliente.portal
          d.escalera = this.direccionCliente.escalera
          d.planta = this.direccionCliente.planta
          d.puerta = this.direccionCliente.puerta
          d.localidad = this.direccionCliente.localidad
          d.municipio = this.direccionCliente.municipio
          d.cp = this.direccionCliente.cp
          d.provincia = this.direccionCliente.provincia
          d.pais = this.direccionCliente.pais

          p.direcciones.push(d)

          errorAlGuardar = await this.$store.dispatch('personasStore/addPersona', p)
            .then((response)   => { 
              this.clienteId = response.data.id
              this.clienteDireccionId = response.data.direcciones[0].id
            })
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })
        } else if (this.clienteDireccionId === null) {  // A persoa existía na BD pero o usuario non seleccionou ningunha dirección da persoa e hai que crear unha nova
          // Actualizamos a data de nacemento do cliente por se non existía
          const c = {}
          c.id = this.clienteId
          c.fechaNacimiento = this.cliente.persona.fechaNacimiento
          console.log(c)
          await this.$store.dispatch('personasStore/updatePersona', c)
          
          // Gardamos unha nova dirección
          const d = {}
          d.persona = `/api/personas/${this.clienteId}`
          d.direccion = this.direccionCliente.direccion
          d.numero = this.direccionCliente.numero
          d.portal = this.direccionCliente.portal
          d.escalera = this.direccionCliente.escalera
          d.planta = this.direccionCliente.planta
          d.puerta = this.direccionCliente.puerta
          d.localidad = this.direccionCliente.localidad
          d.municipio = this.direccionCliente.municipio
          d.cp = this.direccionCliente.cp
          d.provincia = this.direccionCliente.provincia
          d.pais = this.direccionCliente.pais

          errorAlGuardar = await this.$store.dispatch('personasStore/addDireccion', d)
            .then((response) => {
              this.clienteDireccionId = response.data.id
            })
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })
        }

        if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos

        // Construimos o obxecto OperacionPersona para actulizalo cos datos do novo cliente e dirección
        const op = {}
        op.id = this.cliente.id
        op.persona = `/api/personas/${this.clienteId}`
        op.telefono = this.cliente.telefono
        op.email = this.cliente.email
        op.direccion = `/api/direccions/${this.clienteDireccionId}`

        errorAlGuardar = await this.$store.dispatch('operacionesStore/updateOperacionPersona', op)
          .then(() => {})
          .catch((error) => {
            this.showUpdateError(error)
            return true
          })

        if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos

        // Verificamos se na operación está marcado que o titular da conta é o mesmo que o cliente, e nese caso cambiamos por 'NO'
        if (this.operacion.titularIgualCliente === 'S') {
          const o = {}
          o.id = this.operacion.id
          o.titularIgualCliente = 'N'
          // Gardamos a operación
          await this.$store.dispatch('operacionesStore/updateOperacion', o)
            .then(() => {})
            .catch((error) => {
              this.showUpdateError(error)
            })
        }

        this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      } else {
        if (this.clienteTelefono !== this.cliente.telefono || this.clienteEmail !== this.cliente.email) {
          this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
          cambios = true
          // Gardamos operacionPersona (teléfono e mail)
          const op = {}
          op.id = this.cliente.id
          op.telefono = this.cliente.telefono
          op.email = this.cliente.email
          // Gardamos a OperacionPersona
          errorAlGuardar = await this.$store.dispatch('operacionesStore/updateOperacionPersona', op)
            .then(() => {})
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })
          this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
        } 

        if (this.cliente.direccion === undefined || (this.direccionCliente.direccion !== this.cliente.direccion.direccion || this.direccionCliente.numero !== this.cliente.direccion.numero
          || this.direccionCliente.portal !== this.cliente.direccion.portal || this.direccionCliente.escalera !== this.cliente.direccion.escalera
          || this.direccionCliente.planta !== this.cliente.direccion.planta || this.direccionCliente.puerta !== this.cliente.direccion.puerta
          || this.direccionCliente.localidad !== this.cliente.direccion.localidad || this.direccionCliente.municipio !== this.cliente.direccion.municipio
          || this.direccionCliente.cp !== this.cliente.direccion.cp || this.direccionCliente.provincia !== this.cliente.direccion.provincia
          || this.direccionCliente.pais !== this.cliente.direccion.pais)) {
          this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
          cambios = true
          // Gardamos unha nova dirección
          const d = {}
          d.persona = `/api/personas/${this.clienteId}`
          d.direccion = this.direccionCliente.direccion
          d.numero = this.direccionCliente.numero
          d.portal = this.direccionCliente.portal
          d.escalera = this.direccionCliente.escalera
          d.planta = this.direccionCliente.planta
          d.puerta = this.direccionCliente.puerta
          d.localidad = this.direccionCliente.localidad
          d.municipio = this.direccionCliente.municipio
          d.cp = this.direccionCliente.cp
          d.provincia = this.direccionCliente.provincia
          d.pais = this.direccionCliente.pais

          errorAlGuardar = await this.$store.dispatch('personasStore/addDireccion', d)
            .then((response) => {
              this.clienteDireccionId = response.data.id
            })
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })

          if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos

          // Construimos o obxecto OperacionPersona para actulizalo cos datos da nova direccion
          const op = {}
          op.id = this.cliente.id
          op.direccion = `/api/direccions/${this.clienteDireccionId}`

          errorAlGuardar = await this.$store.dispatch('operacionesStore/updateOperacionPersona', op)
            .then(() => {})
            .catch((error) => {
              this.showUpdateError(error)
              return true
            })

          this.$vs.loading.close()  // Pechamos a animación de 'cargando...'

          if (errorAlGuardar) return  // En caso de producirse erro ao gardar na chamada anterior saimos

          // Se na operación está indicado que a dirección de instalación é a mesma ca do cliente, consultamos se tamén a quere actualizar
          if (this.operacion.direccionClienteIgualInstalacion === 'S') this.popupActualizarDireccionInstalacionActivo = true
          
        }      
      }

      // Se se fixeron cambios actualizamos a operación no State
      if (cambios) {
        if (!errorAlGuardar) {
          await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)
          this.showUpdateSuccess('CLIENTE ACTUALIZADO', 'Los datos del cliente han sido guardados correctamente.')
        }
      } else {
        this.showUpdateSuccess('CLIENTE ACTUALIZADO', 'Los datos del cliente han sido guardados correctamente.')
      }
    },
    showUpdateSuccess (titulo, texto) {
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showUpdateError (error) {
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: error
      })
    },
    reset_data () {
      this.$router.push({name: 'operaciones'})
    },
    async actualizarDireccionInstalacion () {
      this.popupActualizarDireccionInstalacionActivo = false
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'

      const o = {}
      o.id = this.operacion.id
      o.direccion = `/api/direccions/${this.clienteDireccionId}`
      // Gardamos a operación
      await this.$store.dispatch('operacionesStore/updateOperacion', o)
        .then(() => { 
          this.showUpdateSuccess('DIRECCIÓN DE INSTALACIÓN ACTUALIZADA', 'Los datos la dirección de instalación han sido guardados correctamente.')
        })
        .catch((error) => {
          this.showUpdateError(error)
        })
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
    },
    async noActualizarDireccionInstalacion () {
      this.popupActualizarDireccionInstalacionActivo = false
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'

      const o = {}
      o.id = this.operacion.id
      o.direccionClienteIgualInstalacion = 'N'
      // Gardamos a operación
      await this.$store.dispatch('operacionesStore/updateOperacion', o)
        .then(() => {})
        .catch((error) => {
          this.showUpdateError(error)
        })
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
    },
    borrarCamposCliente () {
      // Habilitamos os campos (con eles deshabilitanos cambiar os valores compórtase erróneamente)
      this.clienteDisabled = false
      this.fechaNacimientoClienteDisabled = false

      // Baleiramos os campos por se chama ao popup máis dunha vez e selecciona outros valores
      this.clienteId = null
      this.clienteDireccionId = null
      this.clienteTelefono = null
      this.clienteEmail = null
      this.cliente.persona.fechaNacimiento = null
      this.cliente.persona.nombre = null
      this.cliente.persona.apellidos = null
      this.cliente.telefono = null
      this.cliente.email = null
      this.direccionCliente.direccion = null
      this.direccionCliente.numero = null
      this.direccionCliente.portal = null
      this.direccionCliente.escalera = null
      this.direccionCliente.planta = null
      this.direccionCliente.puerta = null
      this.direccionCliente.localidad = null
      this.direccionCliente.municipio = null
      this.direccionCliente.cp = null
      this.direccionCliente.provincia = null
      this.direccionCliente.pais = null
      // Deshabilitamos os campos
      this.clienteDisabled = true
      this.fechaNacimientoClienteDisabled = true

    },
    abrirPopupBuscarPersona (relacion) {
      this.popupProps.relacion = relacion
      if (!this.errors.has('dniCliente') && this.cliente.persona.dni !== null && this.cliente.persona.dni !== undefined) {
        this.popupProps.dni = this.cliente.persona.dni
        this.clienteDireccionId = null // Reseteamos o valor por si tiña asignado un id e se volve chamar ao popup
        // Borramos os datos dos campos por se se chama ao popup máis dunha vez e non se quede algún campo co valor anterior
        this.borrarCamposCliente()
        // Chamamos ao método do popup
        this.$refs.consultarDni.consultarDni()
      }
    },
    popupBuscarPersonaAction (persona) {
      this.popupProps.activo = false  // Pechamos o popup
      if (persona.existe) { //Se a persoa existe imos asignando os datos aos campos do formuario, senón habilitamos os campos para introducilos a man
        this.clienteDisabled = false // Habilitamos os campos para asignarlle os valores
        this.fechaNacimientoClienteDisabled = false

        this.clienteId = persona.personaId  // Asignamos o id da persoa atopada
        this.cliente.persona.fechaNacimiento = persona.fechaNacimiento
        this.cliente.persona.nombre = persona.nombre
        this.cliente.persona.apellidos = persona.apellidos

        this.clienteDisabled = true // Deshabilitamos os campos que xa teñen os valores asignados
        // Se o cliente non tiña data de nacemento mantemos o campo habilitado para que o usuario a poida introducir
        if (this.cliente.persona.fechaNacimiento !== null && this.cliente.persona.fechaNacimiento !== undefined) this.fechaNacimientoClienteDisabled = true

        if (persona.direccion !== 'NUEVA') {  //Se se seleccionou unha dirección cubrimos os campos, senón habilitámolos para engadilos a man
          this.clienteDireccionId = persona.direccionId // Asignamos o id da dirección seleccionada da persoa atopada
          this.direccionCliente.direccion = persona.direccion
          this.direccionCliente.numero = persona.numero
          this.direccionCliente.portal = persona.portal
          this.direccionCliente.escalera = persona.escalera
          this.direccionCliente.planta = persona.planta
          this.direccionCliente.puerta = persona.puerta
          this.direccionCliente.localidad = persona.localidad
          this.direccionCliente.municipio = `/api/val_municipios/${persona.municipioId}`
          this.direccionCliente.cp = persona.cp
          this.direccionCliente.provincia = `/api/val_provincias/${persona.provinciaId}`
          this.direccionCliente.pais = persona.pais
        } else {
          this.clienteDireccionId = null  // Borramos o id da dirección anterior (a que estaba en BD)
        }
        if (persona.movil !== 'NUEVO') {  //Se se seleccionou un móbil cubrimos o campo, senón habilitámolo para que o usuario o engada
          this.cliente.telefono = persona.movil
        }
        if (persona.email !== 'NUEVO') {  //Se se seleccionou un e-mail cubrimos o campo, senón habilitámolo para que o usuario o engada
          this.cliente.email = persona.email
        }
      } else { // A persoa non existe na BD. Habilitamos todos os campos para introducir a man
        this.clienteDisabled = false
        this.fechaNacimientoClienteDisabled = false
        this.clienteId = null
      }
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    if (!personasStore.isRegistered) {
      this.$store.registerModule('personasStore', personasStore)
      personasStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    this.cliente = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion.operacionPersonas.find(({ relacion }) => relacion === 'CLIENTE')))
    if (this.cliente.hasOwnProperty('direccion')) this.direccionCliente = JSON.parse(JSON.stringify(this.cliente.direccion))
    this.clienteId = this.cliente.persona.id
    if (this.cliente.hasOwnProperty('direccion')) this.clienteDireccionId = this.cliente.direccion.id
    this.clienteTelefono = this.cliente.telefono
    this.clienteEmail = this.cliente.email
  }
}
</script>

